module.exports = __webpack_public_path__ + "img/home-works-1.1454eaa0.png";